var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.58,
    x2: 504.532,
    y1: 396.562,
    y2: 121.194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcfdee",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6288,
    stopColor: "#d2f3e4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4.896 331.392c17.448 172.872 292.417 167.143 420.804 136.265 82.47-19.834 87.596-59.472 86.106-144.001-.96-54.486 3.443-198.725-32.004-244.123-54.448-69.733-103.228-25.998-170.656-3.235-86.488 29.197-120.189-22.932-202.476-21.38-120.641 2.278-110.779 187.252-101.774 276.474z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.47 459.267h-398.94c-8.284 0-15-6.716-15-15v-314.267c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15.001-15 15.001z",
    fill: "#2626bc",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 435.267h-398.94c-8.284 0-15-6.716-15-15v-314.267c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15.001-15 15.001z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 160.313v-54.313c0-8.284-6.716-15-15-15h-398.94c-8.284 0-15 6.716-15 15v54.313z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.471 440.266h-398.942c-11.028 0-20-8.972-20-20v-314.266c0-11.028 8.972-20 20-20h398.941c11.028 0 20 8.972 20 20v314.266c.001 11.028-8.971 20-19.999 20zm-398.942-344.266c-5.514 0-10 4.486-10 10v314.266c0 5.514 4.486 10 10 10h398.941c5.514 0 10-4.486 10-10v-314.266c0-5.514-4.486-10-10-10z",
    fill: "#2626bc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 85.623,
    cy: 127.901,
    fill: "#ff5ba8",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.424,
    cy: 127.901,
    fill: "#fff",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.224,
    cy: 127.901,
    fill: "#02ffb3",
    r: 10.901
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.277 140.149h-136.158v-24.496h136.159c2.761 0 5 2.239 5 5v14.496c-.001 2.761-2.239 5-5.001 5z",
    fill: "#ffdbed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.789 115.965c-5.286-5.286-13.887-5.286-19.173 0s-5.286 13.887 0 19.173c4.037 4.037 10.003 4.98 14.953 2.852l4.348 4.348c1.952 1.952 5.119 1.952 7.071 0s1.952-5.119 0-7.071l-4.348-4.348c2.129-4.951 1.186-10.918-2.851-14.954zm-12.102 7.071c1.387-1.387 3.644-1.387 5.031 0s1.387 3.644 0 5.031-3.644 1.387-5.031 0c-1.387-1.388-1.387-3.644 0-5.031z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m173.469 265.324h-98.77c-2.761 0-5-2.239-5-5v-74.288c0-2.761 2.239-5 5-5h98.77c2.761 0 5 2.239 5 5v74.288c0 2.761-2.239 5-5 5z",
    fill: "#02ffb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.385 265.324h-98.77c-2.761 0-5-2.239-5-5v-74.288c0-2.761 2.239-5 5-5h98.77c2.761 0 5 2.239 5 5v74.288c0 2.761-2.239 5-5 5z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.301 265.324h-98.77c-2.761 0-5-2.239-5-5v-74.288c0-2.761 2.239-5 5-5h98.77c2.761 0 5 2.239 5 5v74.288c0 2.761-2.239 5-5 5z",
    fill: "#02ffb3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m437.301 410.165h-362.602c-2.761 0-5-2.239-5-5v-116.391c0-2.761 2.239-5 5-5h362.601c2.761 0 5 2.239 5 5v116.391c.001 2.761-2.238 5-4.999 5z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.836 283.774h-90.137c-2.761 0-5 2.239-5 5v116.391c0 2.761 2.239 5 5 5h90.136v-126.391z",
    fill: "#ffa8cf"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188 303.017h53.181c2.761 0 5 2.239 5 5s-2.239 5-5 5h-53.181c-2.761 0-5-2.239-5-5s2.239-5 5-5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.819 303.017h17.181c2.761 0 5 2.239 5 5s-2.239 5-5 5h-17.181c-2.761 0-5-2.239-5-5s2.239-5 5-5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.003 323.505h83.177c2.761 0 5 2.239 5 5s-2.239 5-5 5h-83.177c-2.761 0-5-2.239-5-5s2.239-5 5-5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m188.003 343.992h225.997c2.761 0 5 2.239 5 5s-2.239 5-5 5h-225.997c-2.761 0-5-2.239-5-5s2.239-5 5-5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.003 364.48h225.997c2.761 0 5 2.239 5 5s-2.239 5-5 5h-225.997c-2.761 0-5-2.239-5-5s2.239-5 5-5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m188.003 394.968c-2.761 0-5-2.239-5-5s2.239-5 5-5h225.997c2.761 0 5 2.239 5 5s-2.239 5-5 5",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m360.721 66.362c-7.881 0-14.292-6.411-14.292-14.292 0-7.88 6.411-14.291 14.292-14.291 7.88 0 14.291 6.411 14.291 14.291 0 7.881-6.411 14.292-14.291 14.292zm0-18.583c-2.366 0-4.292 1.925-4.292 4.291s1.926 4.292 4.292 4.292 4.291-1.926 4.291-4.292-1.925-4.291-4.291-4.291z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.225 72.939c-7.881 0-14.292-6.411-14.292-14.291 0-7.881 6.411-14.292 14.292-14.292 7.88 0 14.291 6.411 14.291 14.292 0 7.88-6.412 14.291-14.291 14.291zm0-18.583c-2.366 0-4.292 1.926-4.292 4.292s1.926 4.291 4.292 4.291 4.291-1.925 4.291-4.291-1.925-4.292-4.291-4.292z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.469 484.889c-7.88 0-14.291-6.411-14.291-14.292 0-7.88 6.411-14.291 14.291-14.291 7.881 0 14.292 6.411 14.292 14.291 0 7.881-6.411 14.292-14.292 14.292zm0-18.583c-2.366 0-4.291 1.925-4.291 4.291s1.925 4.292 4.291 4.292 4.292-1.926 4.292-4.292-1.926-4.291-4.292-4.291z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff5ba8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m314.486 54.694c-2.762 0-5-2.238-5-5 0-3.309-2.692-6-6.001-6-2.762 0-5-2.238-5-5s2.238-5 5-5c3.309 0 6.001-2.691 6.001-6 0-2.762 2.238-5 5-5s5 2.238 5 5c0 3.309 2.691 6 5.999 6 2.762 0 5 2.238 5 5s-2.238 5-5 5c-3.308 0-5.999 2.691-5.999 6 0 2.762-2.238 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.084 489.306c-2.762 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.762 0-5-2.238-5-5s2.238-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.238-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.762 0 5 2.238 5 5s-2.238 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.238 5-5 5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.b9f02dd61f5b8d35b64461e2d34a9870.svg";
export { ForwardRef as ReactComponent };